import m from "../../geodata/es2015/dominicanRepublicMuniHigh";
window.am4geodata_dominicanRepublicMuniHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/dominicanRepublicMuniHigh.js
// module id = null
// module chunks = 